module.exports = __webpack_public_path__ + "static/media/ada.e235a467.png";